import { FILTERS } from '@/types/ui';

export const SEARCH_CONSTANTS = {
  PLACEHOLDER_KEY: 'common.search',
  DEFAULT_REDIRECT_PATH: '/',
} as const;

const isTrainingVideoListRoute = (routePath: string, slug: string | string[] | undefined) => {
  if (slug) return false;
  return routePath.includes('/developer-vault') || routePath.includes('/training');
};

export const useSearchHelpers = () => {
  const router = useRouter();
  const route = useRoute();
  const { isDesktop } = useAppBreakpoints();

  const performSearch = (query: string, onComplete?: () => void) => {
    const routePath = route.path || '';
    const currentQuery = { ...route.query };
    const isTrainingPage = isTrainingVideoListRoute(routePath, route.params?.slug);
    const isExplorePage = routePath === '/explore' || routePath === '/explore';
    const hasExploreQuery =
      currentQuery.explore === '1' || currentQuery.explore === 'true' || currentQuery.explore === 'map';
    const isPrelaunchPage = routePath === '/' || routePath === '/';
    const trimmedQuery = query.trim();

    if (isTrainingPage) {
      if (trimmedQuery) {
        const { searchQuery, fetchVideos } = useTraining();
        searchQuery.value = trimmedQuery;
        fetchVideos();
      }
      onComplete?.();
    } else if (isExplorePage || hasExploreQuery) {
      const { getFilter, setFilter } = useFiltersStore();
      const filterKey = hasExploreQuery && !isExplorePage ? FILTERS.PROPERTIES : FILTERS.EXPLORE;

      const filters = getFilter(filterKey) || {};
      filters.query = trimmedQuery;
      if (filterKey === FILTERS.PROPERTIES) {
        filters.prelaunchQuery = trimmedQuery;
      } else {
        filters.exploreQuery = trimmedQuery;
      }
      setFilter(filterKey, filters);

      if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('explore-search', { detail: { query: trimmedQuery } }));
      }

      onComplete?.();
    } else if (isPrelaunchPage && !isDesktop.value) {
      const { getFilter, setFilter } = useFiltersStore();
      const filters = getFilter(FILTERS.PROPERTIES) || {};
      filters.query = trimmedQuery;
      filters.prelaunchQuery = trimmedQuery;
      setFilter(FILTERS.PROPERTIES, filters);

      if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('explore-search', { detail: { query: trimmedQuery } }));
      }

      onComplete?.();
    } else {
      if (trimmedQuery) {
        const shouldPreserveList = isPrelaunchPage && (currentQuery.list === '1' || currentQuery.list === 'true');

        router.push({
          path: SEARCH_CONSTANTS.DEFAULT_REDIRECT_PATH,
          query: {
            ...(shouldPreserveList ? { list: '1' } : {}),
            search: trimmedQuery,
          },
        });
      }
      onComplete?.();
    }
  };

  const clearSearch = (searchQuery: Ref<string>, isExpanded: Ref<boolean>) => {
    const routePath = route.path || '';
    const isTrainingPage = isTrainingVideoListRoute(routePath, route.params?.slug);

    if (isTrainingPage) {
      const { searchQuery: trainingSearchQuery, fetchVideos } = useTraining();
      trainingSearchQuery.value = '';
      fetchVideos();
    }

    searchQuery.value = '';
    isExpanded.value = false;
  };

  return {
    performSearch,
    clearSearch,
  };
};
